import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "input-box" }
const _hoisted_2 = {
  key: 0,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message) = $event)),
      maxlength: "200",
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeText && _ctx.changeText(...args)))
    }, null, 544), [
      [_vModelText, _ctx.message]
    ]),
    (_ctx.showError)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t('Character limit (200) reached!')), 1))
      : _createCommentVNode("", true)
  ]))
}